import moment from 'moment';
import '../../../utils/moment-extensions';

/**
 * @param {object} doctorLocation
 */
function parseApiV1DoctorLocationTimes(doctorLocation) {
    const dates = {};
    const nextAppointment = doctorLocation.next_appointment || {};
    const nextAppointmentDate = nextAppointment.date ? moment(nextAppointment.date) : null;

    doctorLocation.dates.forEach(date => {
        const currentDate = moment(date.date);

        dates[date.date] = {
            date: currentDate,
            appointments: date.appointments,
        };

        if (nextAppointmentDate && currentDate.dayDiff(nextAppointmentDate) <= 0) {
            dates[date.date].nextAppointment = nextAppointmentDate;
        }
    });

    return dates;
}

export default parseApiV1DoctorLocationTimes;
